import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from './Provider';
import PrivateRouteWithAuth from './PrivateRouteWithAuth';

const PrivateRoute = props => (
  <AuthContext.Consumer>
    {auth => (
      <PrivateRouteWithAuth auth={auth} {...props} />
    )}
  </AuthContext.Consumer>
);

PrivateRoute.defaultProps = {
  permissionsAllowed: [],
};

PrivateRoute.propTypes = {
  component: PropTypes.element.isRequired,
  permissionsAllowed: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/PrivateRoute.jsx